import { useState } from "react";
import { FiImage } from "react-icons/fi";
import { getMediaPreviewColors } from "../../../shared/components/media/MediaSelectionPreview";

interface ImageProps {
    imageUrl?: string | null;
    alt?: string;
}

export const ImageComponent: React.FC<ImageProps> = ({ imageUrl, alt }) => {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);
    const fallbackColors = getMediaPreviewColors(alt || "category");

    if (!imageUrl || error) {
        return (
            <div
                className="image-fallback"
                style={{
                    backgroundColor: fallbackColors.background,
                    color: fallbackColors.color,
                }}
                aria-hidden="true"
            >
                <FiImage size={18} strokeWidth={2.6} />
            </div>
        );
    }

    return (
        <div className="image-wrapper">
            {!loaded && <div className="image-shimmer" />}
            <img
                src={imageUrl}
                alt={alt || "category"}
                onLoad={() => setLoaded(true)}
                onError={() => setError(true)}
                style={{ display: loaded ? "block" : "none" }}
            />
        </div>
    );
};
